import { render, staticRenderFns } from "./_slug.vue?vue&type=template&id=42170c3b&"
import script from "./_slug.vue?vue&type=script&lang=js&"
export * from "./_slug.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CategoryLevel1: require('/www/togihome-buyer/components/category/CategoryLevel1.vue').default,CategoryLevel3: require('/www/togihome-buyer/components/category/CategoryLevel3.vue').default})
